<!--
 * @Author: M.D.
 * @Date: 2020-01-10 11:00:53
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="glg-out-r">
    <ul class="glg-ul" v-if="gdsData.length !== 0">
      <li class="glg-item-li-1" @click="goToGdsDetail(i)" v-for="(i, index) in gdsData" :key="index">
        <el-card class="glg-item-li-card">
          <div class="img-glg-img-w">
            <img :src="tImgUrl(i.image.split(',')[0])" class="image" :onerror="errImgDefault">
            <img v-if="i.videoUrl" class="active-icon" src="~@/assets/image/active.png">
          </div>
          <div class="gds-d-i-c-w">
            <div class="gds-d-name">{{i.name}}</div>
            <!-- <div class="gds-d-rate">{{ goodInfo(i) }}</div> -->
            <div class="gds-d-i-bottom">
              <span class="gds-d-i-curP" v-if="i.type == 5" style="display: block">
                {{ i.partnerName}}
              </span>
              <span class="gds-d-i-curP" v-if="i.type != 5">
                <span class="unit" v-if="i.isOnPay === 1">￥</span>
                {{ i.isOnPay !== 1 ? '价格面议' : `${getFinalPrice(i)}`}}
              </span>
              <span v-if= "i.discountPrice !== -1 && i.isOnPay === 1" class="gds-d-i-orgP">
                <span class="unit">￥</span>
                {{i.price}}
              </span>
            </div>
          </div>
        </el-card>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    gdsData: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: '1'
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  activated () {

  },
  deactivated () {

  },
  watch: {

  },
  methods: {
    goToGdsDetail (i) {
      this.$router.push({ name: 'productDetail', params: { prodId: i.id, type: this.type } })
    },
    goodInfo (item) {
      // 销量106 | 好评率96%
      let el = ``
      if (item.saleNum) {
        el += `销量${item.saleNum}`
      }
      if (item.feedbackRate) {
        if (item.saleNum) {
          el += ` | `
        }
        el += `好评率${item.feedbackRate * 100}%`
      }
      return el
    }
  },
  components: {

  }
}
</script>

<style lang="stylus" scoped>
.glg-order-w
  margin-top 20px
  background-color #ffffff
  .glg-ul
    display flex
    flex-wrap wrap
    overflow hidden
    padding 20px 0 10px 0
    .glg-item-li-1
      // background-color red
      width 33%
      font-size 14px
      margin-bottom 20px
      box-sizing border-box
      center()
      .glg-item-li-card
        width 100%
        .img-glg-img-w
          goods-img-wrapper()
          width 100%
          .active-icon
            width 37px
            height 37px
            position absolute
            margin auto
            top 0
            right 0
            bottom 0
            left 0
            z-index 99
          .image
            goods-img-image()
        .gds-d-i-c-w
          .gds-d-name
            height 21px
            text-overflow ellipsis
            white-space nowrap
            line-height 21px
            overflow hidden
            margin 6px 0
            color #333333
            font-size 15px
          .gds-d-rate
            color #999999
            font-size 12px
            margin 8px 0
          .gds-d-i-bottom
            margin-top 10px
            .gds-d-i-curP
              // width 100px
              // display -webkit-box
              // -webkit-box-orient vertical
              // -webkit-line-clamp 2
              word-break break-all
              white-space nowrap
              text-overflow ellipsis
              overflow hidden
              color orange-color
              margin-right 12px
              font-size 20px
              .unit
                font-size 16px
            .gds-d-i-orgP
              font-size 14px
              color #999999
              text-decoration line-through
      &:nth-child(4n+1)
        .glg-item-li-card
          margin-left 0
          margin-right 15px
      &:nth-child(4n+2)
        .glg-item-li-card
          margin-left 5px
          margin-right 10px
      &:nth-child(4n+3)
        .glg-item-li-card
          margin-left 10px
          margin-right 5px
      &:nth-child(4n+4)
        .glg-item-li-card
          margin-right 0
          margin-left 15px
</style>
